import React from 'react';
import { connect } from 'react-redux';

import { IRootState } from '../../../../modules/stores';

type IConnectProps = ReturnType<typeof mapState>;
interface IProps {
  fieldId: string;
  recordId?: string;
  id?: string;
}

const Raw: React.FC<{ value: string }> = ({ value }) => (
  <span style={{ whiteSpace: 'pre-wrap' }}>{value}</span>
);
const WithFieldId: React.FC<IProps & IConnectProps> = ({ cell, id }) => (
  <span style={{ whiteSpace: 'pre-wrap' }} id={id}>
    {cell}
  </span>
);

const mapState = ({ core }: IRootState, { recordId, fieldId }: IProps) => ({
  cell: core.recordById[recordId || core.currentRecordId]?.cells[fieldId],
});

export default {
  Raw: Raw,
  WithFieldId: connect(mapState)(WithFieldId),
};
